import { render } from "./NavbarSettings.vue?vue&type=template&id=56160fc4"
import script from "./NavbarSettings.vue?vue&type=script&lang=js"
export * from "./NavbarSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__